module.exports = __webpack_public_path__ + "img/logo.8cedc445.png";